import React from 'react';

export interface IconDiamondProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconDiamond: React.FC<IconDiamondProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 81 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <rect x="0.5" width="80" height="80" rx="40" fill={fill || "#FEF3C7"} /> <path fillRule="evenodd" clipRule="evenodd" d="M26.9493 25.3333L22.1667 34.5965L40.5 54.6666L58.8334 34.5965L54.0507 25.3333H26.9493Z" stroke={stroke || "#B45309"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M23.0833 34.5H57.9166" stroke={stroke || "#B45309"}  strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" /> <path d="M33.7059 34.5L40.5 25.3333L47.2941 34.5" stroke={stroke || "#B45309"}  strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" /> <path d="M33.1667 34.5L40.5 54.6667L47.8334 34.5" stroke={stroke || "#B45309"}  strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />  
    </svg>
  );
};

export default IconDiamond;
